import { itwApi } from '@application/api/middlewares/api';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
const initialState = {
    dashboard: null,
    loading: false,
    error: null,
    assetId: '',
    projectId: '',
    topIncident: '24Hrs',
    dropDownLists: {
        projects: [],
        assets: []
    },
    fromDate: null,
    toDate: null
};
export const fetchDashboardDetails = createAsyncThunk('applicationDashboard/fetchApplicationDashboard', async (_, { getState, rejectWithValue }) => {
    const state = getState();
    const { assetId, projectId, topIncident, fromDate, toDate } = state.dashboardSlice;
    const params = { assetId, projectId, topIncident, fromDate, toDate };
    try {
        const response = await itwApi.get('Dashboard/get-application-dashboard', { params });
        return response.data;
    }
    catch (error) {
        return rejectWithValue(error.response?.data?.message || 'Failed to fetch dashboard details');
    }
});
export const fetchDashboardDropDowns = createAsyncThunk('applicationDashboard/fetchDashboardDropDowns', async (_, { getState, rejectWithValue }) => {
    const state = getState();
    const { projectId } = state.dashboardSlice;
    const params = { projectId };
    try {
        const response = await itwApi.get('Dashboard/get-drop-downs-dashboard', { params });
        return response.data;
    }
    catch (error) {
        return rejectWithValue(error.response?.data?.message || 'Failed to fetch dashboard dropdowns');
    }
});
export const dashboardSlice = createSlice({
    name: 'applicationDashboard',
    initialState,
    reducers: {
        clearDashboard(state) {
            state.dashboard = null;
        },
        setTopIncident(state, action) {
            state.topIncident = action.payload;
        },
        setAssetId(state, action) {
            state.assetId = action.payload;
        },
        setProjectId(state, action) {
            state.projectId = action.payload;
        },
        resetProjectId(state) {
            state.projectId = '';
            state.assetId = '';
        },
        resetAssetId(state) {
            state.assetId = '';
        },
        setFromDate(state, action) {
            state.fromDate = action.payload;
        },
        setToDate(state, action) {
            state.toDate = action.payload;
        },
        resetFilters(state) {
            state.projectId = null;
            state.assetId = null;
            state.fromDate = null;
            state.toDate = null;
            state.topIncident = '24Hrs';
        },
        resetDate(state) {
            state.fromDate = null;
            state.toDate = null;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchDashboardDetails.pending, (state) => {
            state.loading = true;
            state.error = null;
        })
            .addCase(fetchDashboardDetails.fulfilled, (state, action) => {
            state.loading = false;
            state.dashboard = action.payload;
        })
            .addCase(fetchDashboardDetails.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        })
            .addCase(fetchDashboardDropDowns.pending, (state) => {
            state.loading = true;
            state.error = null;
        })
            .addCase(fetchDashboardDropDowns.fulfilled, (state, action) => {
            state.loading = false;
            state.dropDownLists = {
                projects: action.payload.data.projects,
                assets: action.payload.data.assets
            };
        })
            .addCase(fetchDashboardDropDowns.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });
    }
});
export const { clearDashboard, setTopIncident, setProjectId, setAssetId, resetAssetId, resetProjectId, setFromDate, setToDate, resetDate, resetFilters } = dashboardSlice.actions;
export default dashboardSlice.reducer;
